/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import DocumentViewCard from "./DocumentViewCard";
import { Flex } from "@aws-amplify/ui-react";
export default function HealthRecordsDocumentView(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="24px"
      direction="column"
      width="964px"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
      {...getOverrideProps(overrides, "HealthRecordsDocumentView")}
      {...rest}
    >
      <DocumentViewCard
        display="flex"
        gap="0"
        direction="row"
        width="900px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "DocumentViewCard")}
      ></DocumentViewCard>
    </Flex>
  );
}
